export default __webpack_public_path__ + "static/media/iphone-assignments.b3850f43.png";